import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';

const INT_LABELS = {
  jobs_per_month: 'Job posts per month',
  courses: 'Courses that can be listed',
  events_per_month: 'Events per month',
  featured_credits: 'Featured-listing credits',
  cv_unlocks: 'CV unlocks',
  ai_credits: 'AI credits per month',
};
const BOOL_LABELS = {
  cv_search: 'CV database search',
  featured_jobs: 'Featured jobs',
  analytics: 'Analytics',
};

/**
 * Structured editor for a plan's enforced limits and AI privileges (stored in subscription_plans.limits).
 * Integer limits: -1 = unlimited, 0 = none. `meta` comes from GET /admin/subscription-plans/meta.
 */
export default function PlanLimitsEditor({ limits, onChange, meta }) {
  const L = limits || {};
  const set = (k, v) => onChange({ ...L, [k]: v });
  const allAi = L.ai_features === 'all';
  const aiList = Array.isArray(L.ai_features) ? L.ai_features : [];

  const toggleFeature = (key) => {
    set('ai_features', aiList.includes(key) ? aiList.filter(k => k !== key) : [...aiList, key]);
  };

  return (
    <div className="space-y-4 border rounded-lg p-3 bg-muted/30" data-testid="plan-limits-editor">
      <p className="text-sm font-semibold">Limits &amp; privileges <span className="font-normal text-muted-foreground">(-1 = unlimited, 0 = none)</span></p>
      <div className="grid grid-cols-2 gap-3">
        {(meta?.int_limits || Object.keys(INT_LABELS)).map(k => (
          <div key={k} className="space-y-1">
            <Label className="text-xs">{INT_LABELS[k] || k}</Label>
            <Input type="number" min={-1} value={L[k] ?? 0}
              onChange={e => set(k, e.target.value === '' ? 0 : parseInt(e.target.value, 10))}
              data-testid={`limit-${k}`} />
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-3">
        {(meta?.bool_limits || Object.keys(BOOL_LABELS)).map(k => (
          <div key={k} className="flex items-center gap-2">
            <Switch checked={!!L[k]} onCheckedChange={v => set(k, v)} />
            <Label className="text-xs">{BOOL_LABELS[k] || k}</Label>
          </div>
        ))}
      </div>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <Switch checked={allAi} onCheckedChange={v => set('ai_features', v ? 'all' : [])} data-testid="ai-all" />
          <Label className="text-xs font-medium">All AI features</Label>
        </div>
        {!allAi && (
          <div className="grid grid-cols-2 gap-1">
            {(meta?.ai_features || []).map(f => (
              <label key={f.key} className="flex items-center gap-2 text-xs cursor-pointer">
                <input type="checkbox" checked={aiList.includes(f.key)} onChange={() => toggleFeature(f.key)} />
                <span>{f.label} <span className="text-muted-foreground">({f.audience}, {f.default_cost} cr)</span></span>
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
